import nl from './nl.svg';
import en from './en.svg';
import de from './de.svg';
import es from './es.svg';
import fr from './fr.svg';
import sv from './sv.svg';
import it from './it.svg';

const flags = { nl, en, de, es, fr, sv, it};
export default flags;